/**
 * Okta Authentication Configuration
 */
import { OktaAuth } from '@okta/okta-auth-js';

const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_OKTA_ISSUER || "https://jllpoc.oktapreview.com/oauth2/default",
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID || "0oa2cz1kmmeQQOFzp0h8",
  redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI || window.location.origin + '/login',
  postLogoutRedirectUri: process.env.REACT_APP_OKTA_POST_LOGOUT_REDIRECT_URI || window.location.origin,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  tokenManager: {
    autoRenew: true
  }
});

export default oktaAuth;


